module.exports = __webpack_public_path__ + "files/ace577c1734e4028bee8d7c698686867.png";